/**
 * @generated SignedSource<<fdbf629ec207dad108f4fbc607f9c519>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AnalysisServerCostViewQuery$variables = Record<PropertyKey, never>;
export type AnalysisServerCostViewQuery$data = {
  readonly hetznerNodeCosts: {
    readonly cutOff: any | null | undefined;
    readonly internalClusterCost: number;
    readonly totalClusterCost: number;
    readonly totalServerCost: number;
    readonly types: ReadonlyArray<{
      readonly nodeCount: number;
      readonly perNodeAmount: number;
      readonly platform: string;
      readonly role: string | null | undefined;
      readonly serverType: string;
      readonly totalAmount: number;
    }>;
  };
};
export type AnalysisServerCostViewQuery = {
  response: AnalysisServerCostViewQuery$data;
  variables: AnalysisServerCostViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "HetznerNodeCostReport",
    "kind": "LinkedField",
    "name": "hetznerNodeCosts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cutOff",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalServerCost",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalClusterCost",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "internalClusterCost",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "HetznerNodeCostType",
        "kind": "LinkedField",
        "name": "types",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "platform",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serverType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "perNodeAmount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisServerCostViewQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalysisServerCostViewQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e288e92e1e4cbf80c6b1ad60ec522592",
    "id": null,
    "metadata": {},
    "name": "AnalysisServerCostViewQuery",
    "operationKind": "query",
    "text": "query AnalysisServerCostViewQuery {\n  hetznerNodeCosts {\n    cutOff\n    totalServerCost\n    totalClusterCost\n    internalClusterCost\n    types {\n      platform\n      role\n      serverType\n      nodeCount\n      totalAmount\n      perNodeAmount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad34459a430c1d283185f72276dfb762";

export default node;
